// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .Feedback-root-Zwdi4 {
 	background: var(--primary-white-bg);
 	color: var(--common-text-color);
 	padding: 0px;
 }

 .Feedback-container-ynCq4 {
 	max-width: var(--max-content-width);
 	margin: 0 auto;
 }

 .Feedback-feedbackBox-F9wqd {
 	padding: 45px 35px 45px 45px !important;
 }

 .Feedback-feedbackBox-F9wqd:last-of-type {
 	border-right: 1px solid transparent;
 }

 .Feedback-feedbackRow-c6Uls {
 	border: 1px solid var(--primary-border);
 	border-radius: 12px;
 	margin: 0;
 }

 .Feedback-borderRight-RzUrx {
 	position: relative;
 }

 .Feedback-borderRight-RzUrx::after {
 	content: '';
 	width: 1px;
 	height: 168px;
 	background: var(--primary-border);
 	top: 70px;
 	right: 0px;
 	position: absolute;
 }

 .Feedback-textColor-gX60D {
 	color: var(--common-text-color) !important;
 }

 @media screen and (max-width: 1200px) {
 	.Feedback-feedbackRow-c6Uls {
 		margin: 40px 25px 0;
 	}
 }

 @media screen and (max-width: 767px) {
 	.Feedback-feedbackBox-F9wqd {
 		display: block;
 		float: left;
 		border-bottom: none;
 	}

 	.Feedback-feedbackBox-F9wqd:last-of-type {
 		border-bottom: 1px solid transparent;
 	}

 	.Feedback-feedbackBox-F9wqd {
 		padding: 25px !important;
 	}

 	.Feedback-borderRight-RzUrx::after {
 		display: none;
 	}
 }`, "",{"version":3,"sources":["webpack://./src/components/Feedback/Feedback.css"],"names":[],"mappings":"CAAC;EACC,mCAAmC;EACnC,+BAA+B;EAC/B,YAAY;CACb;;CAEA;EACC,mCAAmC;EACnC,cAAc;CACf;;CAEA;EACC,uCAAuC;CACxC;;CAEA;EACC,mCAAmC;CACpC;;CAEA;EACC,uCAAuC;EACvC,mBAAmB;EACnB,SAAS;CACV;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,UAAU;EACV,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,UAAU;EACV,kBAAkB;CACnB;;CAEA;EACC,0CAA0C;CAC3C;;CAEA;EACC;GACC,mBAAmB;EACpB;CACD;;CAEA;EACC;GACC,cAAc;GACd,WAAW;GACX,mBAAmB;EACpB;;EAEA;GACC,oCAAoC;EACrC;;EAEA;GACC,wBAAwB;EACzB;;EAEA;GACC,aAAa;EACd;CACD","sourcesContent":[" .root {\n \tbackground: var(--primary-white-bg);\n \tcolor: var(--common-text-color);\n \tpadding: 0px;\n }\n\n .container {\n \tmax-width: var(--max-content-width);\n \tmargin: 0 auto;\n }\n\n .feedbackBox {\n \tpadding: 45px 35px 45px 45px !important;\n }\n\n .feedbackBox:last-of-type {\n \tborder-right: 1px solid transparent;\n }\n\n .feedbackRow {\n \tborder: 1px solid var(--primary-border);\n \tborder-radius: 12px;\n \tmargin: 0;\n }\n\n .borderRight {\n \tposition: relative;\n }\n\n .borderRight::after {\n \tcontent: '';\n \twidth: 1px;\n \theight: 168px;\n \tbackground: var(--primary-border);\n \ttop: 70px;\n \tright: 0px;\n \tposition: absolute;\n }\n\n .textColor {\n \tcolor: var(--common-text-color) !important;\n }\n\n @media screen and (max-width: 1200px) {\n \t.feedbackRow {\n \t\tmargin: 40px 25px 0;\n \t}\n }\n\n @media screen and (max-width: 767px) {\n \t.feedbackBox {\n \t\tdisplay: block;\n \t\tfloat: left;\n \t\tborder-bottom: none;\n \t}\n\n \t.feedbackBox:last-of-type {\n \t\tborder-bottom: 1px solid transparent;\n \t}\n\n \t.feedbackBox {\n \t\tpadding: 25px !important;\n \t}\n\n \t.borderRight::after {\n \t\tdisplay: none;\n \t}\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Feedback-root-Zwdi4`,
	"container": `Feedback-container-ynCq4`,
	"feedbackBox": `Feedback-feedbackBox-F9wqd`,
	"feedbackRow": `Feedback-feedbackRow-c6Uls`,
	"borderRight": `Feedback-borderRight-RzUrx`,
	"textColor": `Feedback-textColor-gX60D`
};
module.exports = ___CSS_LOADER_EXPORT___;
